export default __webpack_public_path__ + "static/media/account_circle-24px.53e88564.svg";